import {
    Component,
    ComponentInterface,
    Prop,
    h,
    Event,
} from "@stencil/core";
import type { EventEmitter } from "@stencil/core"

import { Choice } from "../../../../../../utils/backend/reply-parsed";

@Component({
    tag: "c-multiple-choice-buttons",
    styleUrl: "c-multiple-choice-buttons.scss",
})
export class CMultipleChoiceButtons implements ComponentInterface {
    multiChoiceButtonElements: HTMLElement[] = [];
    @Prop() choices: Choice[];
    @Prop() shortLabels: boolean | undefined;
    @Event() choiceSelected: EventEmitter;

    render() {
        return this.choices.map((choice, choiceIndex) => {
            return (
                <li>
                    <button
                        key={choice.title}
                        title={choice.tooltipp ? choice.tooltipp : ""}
                        ref={(el) => {
                            if (el) {
                                this.multiChoiceButtonElements[choiceIndex] =
                                    el;
                            }
                        }}
                        class={`multiple-choice-button ${
                            (this.shortLabels && "small") || ""
                        }`}
                        innerHTML={`${choice.title}`}
                        onClick={() => this.choiceSelected.emit(choice)}
                        data-analytics-track="true"
                        data-analytics-action="ButtonClicks TCB: Klick"
                        data-analytics-value={choice.title}
                        data-analytics-name="TCB: Multiple Choice Button"
                        data-analytics-category="TCB | ButtonClicks"
                    ></button>
                </li>
            );
        });
    }
}
